import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { truncate } from '@bibliocommons/utils-string';

import ExpandButton from './ExpandButton';

import './ExpandableText.scss';

const renderExpandLabel = (isExpanded, textKey) => {
  const labelKey = isExpanded ? 'read_less' : 'read_more';

  return (
    <span>
      <span aria-hidden>
        <FormattedMessage id={labelKey} />
      </span>
      <ScreenReaderMessage>
        <FormattedMessage id={`${labelKey}_${textKey}`} />
      </ScreenReaderMessage>
    </span>
  );
};

const ExpandableText = ({ text, truncateCount, className, dataKey, textKey }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = useCallback(() => {
    setExpanded(prev => !prev);
  }, []);

  const truncatedText = truncate(text, { desiredLength: truncateCount });
  const anyTextTruncated = truncatedText.length !== text.length;

  return (
    <div className={cn('cp-expandable-text', className)}>
      <span className="expandable-text__text" data-key={dataKey}>
        {expanded ? text : truncatedText}
      </span>
      {anyTextTruncated && (
        <ExpandButton
          handleToggle={handleToggle}
          isExpanded={expanded}
          renderLabel={renderExpandLabel}
          textKey={textKey}
        />
      )}
    </div>
  );
};

ExpandableText.propTypes = {
  text: PropTypes.string.isRequired,
  truncateCount: PropTypes.number,
  className: PropTypes.string,
  dataKey: PropTypes.string,
  textKey: PropTypes.string
};

ExpandableText.defaultProps = {
  truncateCount: 250
};

export default ExpandableText;
